import React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';

export const OrganizationSettings = () => {
	return (
		<>
			<Toolbar>
				<span>Organization Settings</span>
			</Toolbar>
			<Divider />
			<Box sx={{ pl: 3 }}>
				<p>Organization Settings</p>
			</Box>
		</>
	);
};
